module.exports = __webpack_public_path__ + "static/media/panorama-pt.7bfe7b55.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/panorama-pt.jpg
 ** module id = 441
 ** module chunks = 0
 **/